import React, { useState } from "react";
import Carousel from "./Carousel";
import { EnvelopeIcon, LockClosedIcon, EyeIcon, EyeSlashIcon } from "@heroicons/react/24/outline";
import { useNavigate } from "react-router-dom";
import { loginService } from "../../api/services/authServices";
import { toast } from "react-toastify";

const Login = () => {
    const [formData, setFormData] = useState({
        email: "",
        password: "",
        remember: false,
    });
    const [showPassword, setShowPassword] = useState(false);
    const navigate = useNavigate();

    const handleInputChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: type === "checkbox" ? checked : value,
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        console.log("Login form submitted:", formData);
        try {
            let response = await loginService(formData);
            console.log("Login response:", response);
            if (response.status === 200) {
                navigate("/");
            }
            else {
                toast.error(response.data.message || "Something went wrong");
            }
        } catch (error) {
            toast.error(error.response.data.error || "Something went wrong");
            console.log("Login error:", error);
        }
    };

    return (
        <div className="flex min-h-screen">
            <div className="w-[30%] hidden md:block">
                <Carousel />
            </div>

            <div className="w-full md:w-[70%] flex items-center justify-center px-4">
                <form
                    onSubmit={handleSubmit}
                    className="bg-white w-full max-w-lg p-8 rounded-[15px] [box-shadow:0px_2px_8px_0px_#80808040] space-y-6"
                >
                    <h2 className="text-2xl font-semibold text-center">Sign In</h2>

                    <div className="border border-gray-300 rounded-lg flex items-center pr-3">

                        <EnvelopeIcon className="w-6 h-6 ml-2 text-[#56B22F]" />

                        <input
                            type="email"
                            name="email"
                            placeholder="Email"
                            value={formData.email}
                            onChange={handleInputChange}
                            className="w-full px-2 py-3 focus:ring-2 focus:ring-transparent focus:border-transparent outline-none"
                            required
                        />
                    </div>

                    <div className="border border-gray-300 rounded-lg flex items-center pr-3">
                        <LockClosedIcon className="w-6 h-6 ml-2 text-[#56B22F]" />

                        <input
                            type={showPassword ? "text" : "password"}
                            name="password"
                            placeholder="Password"
                            value={formData.password}
                            onChange={handleInputChange}
                            className="w-full px-2 py-3 focus:ring-2 focus:ring-transparent focus:border-transparent outline-none"
                            required
                        />

                        <button
                            type="button"
                            onClick={() => setShowPassword((prev) => !prev)}
                            className="ml-2 text-gray-500 hover:text-gray-700"
                        >
                            {showPassword ? (
                                <EyeSlashIcon className="w-5 h-5 text-[#56B22F]" />
                            ) : (
                                <EyeIcon className="w-5 h-5 text-[#56B22F]" />
                            )}
                        </button>
                    </div>

                    <div className="flex items-center justify-between text-sm text-gray-600">
                        <label className="flex items-center space-x-2">
                            <input
                                type="checkbox"
                                name="remember"
                                checked={formData.remember}
                                onChange={handleInputChange}
                            />
                            <span>Remember me</span>
                        </label>
                        <div onClick={() => navigate("/forgot-password")} className="text-[#56B22F] font-medium cursor-pointer">
                            Forgot Password?
                        </div>
                    </div>
                    <button
                        type="submit"
                        className="w-full bg-[#56B22F] text-white py-3 rounded-lg font-semibold hover:bg-[#4a9c28] transition-colors"
                    >
                        Sign In
                    </button>

                    <p className="text-center text-sm text-gray-600">
                        Don’t Have An Account?{" "}
                        <span onClick={() => navigate("/sign-up")} className="text-[#56B22F] font-medium cursor-pointer">
                            Sign Up
                        </span>
                    </p>
                </form>
            </div>
        </div>
    );
};

export default Login;
